// EliminationModal.js

import React from 'react';
import { OptimizedModal } from './OptimizedModal'; // Yeni temel bileşen

// ✅ React.memo ile sarmalandı
export const EliminationModal = React.memo(({ playerName, onClose, isOpen }) => {
    return (
        // ✅ OptimizedModal kullanıldı
        <OptimizedModal isOpen={isOpen} onClose={onClose}>
            <div className="bg-gradient-to-br from-red-900 to-gray-900 border-2 border-red-500 rounded-2xl p-8 text-center shadow-2xl max-w-sm w-full">
                <div className="text-6xl mb-4">💀</div>
                <h2 className="text-red-300 mb-2 text-3xl font-bold">
                    {playerName} ELENDİ!
                </h2>
                <p className="text-gray-300 mb-6">
                    Tüm bölgelerini kaybetti ve oyundan çıkarıldı.
                </p>
                <button
                    onClick={onClose}
                    className="px-8 py-3 rounded-xl font-bold text-white text-md bg-gray-700 hover:bg-gray-600 transition-all"
                >
                    Devam Et
                </button>
            </div>
        </OptimizedModal>
    );
});